import RegisterController2 from "./authWithOtp/RegisterController2";
import React from 'react';
import {registerResetAction} from "./redux";
import * as authActions from '../actions/auth/authWithOtp/authActions2';
import reduxRouteChanged from "../services/reduxRouteChanged";

class RegisterControllerMapper extends React.Component {

  render() {

    return (
      <div>
        <RegisterController2/>
      </div>
    );
  }
}

function initStore(dispatch) {
  dispatch(authActions.loginReset());
  return dispatch(registerResetAction());
}

export default reduxRouteChanged(initStore, RegisterControllerMapper);



// WEBPACK FOOTER //
// ./src/auth/registerControllerMapper.js